import React from "react";
import LoaderShell from "components/Shells/LoaderShell";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function IndexScreen() {
    const history = useHistory();

    setTimeout(() => {
        history.push("/app/dashboard");
    }, 1000);

    return <LoaderShell statusMessage="Loading..." />;
}
